import { render } from "./ReleaseMain.vue?vue&type=template&id=df803b14&scoped=true&ts=true"
import script from "./ReleaseMain.vue?vue&type=script&lang=ts"
export * from "./ReleaseMain.vue?vue&type=script&lang=ts"

import "./ReleaseMain.vue?vue&type=style&index=0&id=df803b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df803b14"]])

export default __exports__